import Dbm from "dbm";
import Website from "../../../index.js";

export default class GroundEnemy extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let height = 84;
        let width = 50;

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        this.item.setValue("sprite", null);
        this.item.setValue("position", Website.game.Sizes.WIDTH+25);
        this.item.setValue("active", false);

        let wheelsGraphics = new Website.game.gameplay.player.SwitchableGraphics();
        this.item.setValue("wheelsGraphics", wheelsGraphics.item);
        
        let armGraphics = new Website.game.gameplay.player.SwitchableGraphics();
        this.item.setValue("armGraphics", armGraphics.item);

        this.item.requireProperty("mode", "intro").addUpdate(this._getScopedCallFunctionCommand(this._modeUpdated));
        this.item.requireProperty("throwMode", "none").addUpdate(this._getScopedCallFunctionCommand(this._throwModeUpdated));
        

        this.item.setValue("x", 0);
        this.item.setValue("y", 0.5*height);

        

        const body = Matter.Bodies.rectangle(0, -0.5*height, width, height, {
            label: "boss",
            isSensor: false,
            isStatic: false,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.ENEMIES, Website.game.PhysicsGroups.ENEMIES_INTERACTIONS)
        });
        
        this.item.setValue("physicsBody", body);

        let speechBubble = new Website.game.gameplay.player.SpeechBubble();
        speechBubble.item.pixiLayer.position.set(-15, -70);
        this.item.setValue("speechBubble", speechBubble.item);

        let noSpeechBubble = new Website.game.gameplay.player.SpeechBubble();
        noSpeechBubble.item.pixiLayer.position.set(-15, -70);
        this.item.setValue("noSpeechBubble", noSpeechBubble.item);

    }

    setIntialPosition(aCameraPosition) {
        let currentPosition = this.item.physicsBody.position;

        let x = this.item.position;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: currentPosition.y
        });
    }

    update(aCameraPosition, aTime, aDelta) {
        //console.log("update");

        let currentPosition = this.item.physicsBody.position;

        let x = this.item.position;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: currentPosition.y
        });

        let height = 84;

        this.item.pixiLayer.x = Math.round(this.item.physicsBody.position.x);
        this.item.pixiLayer.y = Math.round(this.item.physicsBody.position.y)+(0.5*height)+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION-5);

        //console.log(this.item.pixiLayer.x, this.item.pixiLayer.y);
    }

    _modeUpdated() {
        if(this.item.active) {
            if(this.item.mode === "defense") {
                this.item.properties.position.animateValue(0.9*Website.game.Sizes.WIDTH, 0.7);

                let numberOfPlanes = 2+Math.round(Math.random()*3);

                let currentTime = 0;
                for(let i = 0; i < numberOfPlanes; i++) {
                    currentTime += 0.8+Math.random()*0.4;
                    this.item.properties.throwMode.addDelayValue("prepare", currentTime-0.2);
                    this.item.properties.throwMode.addDelayValue("throw", currentTime);
                }
                this.item.properties.mode.delayValue("attack", currentTime+0.5);
                this.item.noSpeechBubble.controller.hide();
            }
            else if(this.item.mode === "attack") {
                this.item.properties.position.animateValue(0.5*Website.game.Sizes.WIDTH, 0.7);
                this.item.properties.mode.delayValue("defense", 2.5);
                this.item.noSpeechBubble.controller.show(0.4);
            }
        }
        
    }

    _throwModeUpdated() {
        if(this.item.active) {
            if(this.item.throwMode === "prepare") {
                this.item.armGraphics.controller.showGraphics("throw");
            }
            else {
                this.item.armGraphics.controller.showGraphics("idle");
                this.item.gamePlay.controller.createBossFlyingEnemy();
            }
        }
    }

    setupGraphics() {

        this.item.wheelsGraphics.controller.addGraphics("walk", Website.game.getAnimatedSprite("enemies/boss", "walk"));
        this.item.wheelsGraphics.controller.addGraphics("stand", Website.game.getSprite("enemies/boss", "layer", 0));

        this.item.pixiLayer.addChild(this.item.wheelsGraphics.pixiLayer);
        this.item.pixiLayer.addChild(Website.game.getSprite("enemies/boss", "layer", 1));
        this.item.pixiLayer.addChild(Website.game.getSprite("enemies/boss", "layer", 2));

        this.item.armGraphics.controller.addGraphics("idle", Website.game.getSprite("enemies/boss", "layer", 3));
        this.item.armGraphics.controller.addGraphics("throw", Website.game.getAnimatedSprite("enemies/boss", "layer-04-throw"));
        
        this.item.pixiLayer.addChild(this.item.armGraphics.pixiLayer);
        this.item.pixiLayer.addChild(Website.game.getSprite("enemies/boss", "layer", 4));

        this.item.speechBubble.controller.setup(140, false);
        this.item.pixiLayer.addChild(this.item.speechBubble.pixiLayer);

        this.item.noSpeechBubble.controller.setup(22, false);
        this.item.pixiLayer.addChild(this.item.noSpeechBubble.pixiLayer);

        this.item.noSpeechBubble.controller.setText("NO!");
    }

    startFight() {
        this.item.active = true;
        this.item.mode = "defense";
        this.item.wheelsGraphics.controller.showGraphics("walk");
        this.item.armGraphics.controller.showGraphics("idle");
    }

    stopFight() {
        this.item.active = false;
        this.item.properties.mode.delayValue("none", 0);
        this.item.properties.throwMode.delayValue("idle", 0);
        this.item.noSpeechBubble.controller.hide();
    }

    hit() {
        this.item.mode = "defense";
        this.item.properties.mode.delayValue("defense", 0);

        Matter.Body.setVelocity(this.item.physicsBody, {
            x: this.item.physicsBody.velocity.x,
            y: -5
        });
    }
}